<template>
  <v-form v-model="valid" ref="form">
    <v-row>
      <v-col class="pb-0">
        <v-text-field
          outlined
          dense
          label="* Name"
          v-model="formData.name"
          :rules="[formRules.required]"
        ></v-text-field>
      </v-col>
    </v-row>

    <v-row>
      <v-col class="py-0">
        <v-text-field
          outlined
          dense
          label="* Email"
          v-model="formData.email"
          :rules="[formRules.required, formRules.email]"
        ></v-text-field>
      </v-col>
    </v-row>

    <v-row>
      <v-col class="py-0">
        <v-text-field
          outlined
          dense
          label="Phone"
          v-model="formData.phone"
        ></v-text-field>
      </v-col>
    </v-row>

    <v-row v-if="inviteToProject">
      <v-col class="py-0">
        <v-select
          outlined
          dense
          label="Role"
          :items="roleOptions"
          v-model="formData.role"
          :rules="[formRules.required]"
        ></v-select>
      </v-col>
    </v-row>

    <v-row>
      <v-col class="pt-0" align="right">
        <v-btn
          depressed
          color="primary"
          :disabled="!valid"
          @click="submit"
          :loading="loading.users"
          >Send</v-btn
        >
      </v-col>
    </v-row>
  </v-form>
</template>

<script>
import { mapState, mapActions } from 'vuex'

export default {
  name: 'UserInviteForm',
  props: {
    inviteToProject: {
      default: null,
      type: Number
    }
  },
  data: () => ({
    valid: true,
    roleOptions: ['client', 'manager', 'worker'],
    formData: {
      name: '',
      email: '',
      phone: '',
      role: null
    },
    formRules: {
      required: v => !!v || 'This field is required.',
      email: v => /.+@.+\..+/.test(v) || 'Must be a valid email.'
    }
  }),
  computed: {
    ...mapState('users', ['loading']),
    inviteUserPayload() {
      return {
        name: this.formData.name,
        email: this.formData.email,
        phone: this.formData.phone,
        project_id: this.inviteToProject,
        role: this.formData.role
      }
    }
  },
  methods: {
    ...mapActions('users', ['inviteUser']),
    submit() {
      this.inviteUser(this.inviteUserPayload)
    }
  }
}
</script>
